import { Link } from "react-router-dom";
import { PiPlusBold } from "react-icons/pi";
import routes from "@/routers/routes";
import { Button } from "rizzui";
import { orderData } from "@/data/order-data";
import PageHeader from "@/app/shared/page-header";
import ExportButton from "@/app/shared/export-button";
import { Category } from "@/types";
import AddCategoryModal from "@/app/shared/categories/add-category-modal";

const pageHeader = {
    title: "All Categories",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Home",
        },
        {
            name: "Categories",
        },
    ],
};

interface HeaderProps {
    categories: Category[];
    handleSave: (category: Category) => void;
    show: boolean;
}

export default function CategoryPageHeader({
    categories: categories,
    handleSave,
    show,
}: HeaderProps) {
    return (
        <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
            <div className="mt-4 flex flex-col items-center gap-3 @sm:flex-row @lg:mt-0">
                <ExportButton
                    data={categories}
                    fileName="order_data"
                    header="ID,Tracking ID,Date,Sender,Receiver,Origin,Destination,Payment Method,Status"
                />
                <AddCategoryModal
                    title="Add Category"
                    description="Add a new category to the list"
                    handleSave={handleSave}
                    show={show}
                />
            </div>
        </PageHeader>
    );
}
